import React, { useState } from "react";

export default function Buttons() {
  const hoverIn = (e, bg, color) => {
    e.currentTarget.style.background = bg;
    e.currentTarget.style.color = color;
  };

  const hoverOut = (e, bg, color) => {
    e.currentTarget.style.background = bg;
    e.currentTarget.style.color = color;
  };

  // ---------- LAYOUT ----------
  const pageStyle = {
    background: "white",
    minHeight: "100vh",
    padding: "40px",
    display: "grid",
    gap: "24px",
    gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
  };

  const wrapperStyle = {
    display: "flex",
    flexDirection: "column",
  };

  const cardStyle = {
    background: "#fff",
    borderRadius: "12px",
    padding: "16px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    aspectRatio: "1/ 1",
    border: "1px dashed #ddd",
  };

  const viewBtnStyle = {
    marginTop: "8px",
    alignSelf: "flex-start",
    background: "#e8e9eb",
    color: "black",
    padding: "4px 10px",
    borderRadius: "8px",
    border: "none",
    fontSize: "12px",
    fontWeight: "600",
    cursor: "pointer",
  };

  // ---------- DATA ----------
  const buttons = [
    { name: "Primary", style: { padding: "8px 10px", borderRadius: "10px", border: "none", background: "#111827", color: "#fff", fontWeight: "600", cursor: "pointer" }, hover: ["#1f2933", "#fff"], out: ["#111827", "#fff"] },
    { name: "Outline", style: { padding: "10px 18px", borderRadius: "10px", border: "2px solid #111827", background: "transparent", color: "#111827", fontWeight: "600", cursor: "pointer" }, hover: ["#111827", "#fff"], out: ["transparent", "#111827"] },
    { name: "Instagram", style: { padding: "10px 20px", borderRadius: "999px", border: "none", background: "linear-gradient(45deg,#f58529,#dd2a7b,#8134af)", color: "#fff", fontWeight: "600", cursor: "pointer" }, hover: ["#c13584", "#fff"], out: ["linear-gradient(45deg,#f58529,#dd2a7b,#8134af)", "#fff"] },
    { name: "Follow", style: { padding: "10px 18px", borderRadius: "999px", border: "none", background: "#1d9bf0", color: "#fff", fontWeight: "600", cursor: "pointer" }, hover: ["#0d8de1", "#fff"], out: ["#1d9bf0", "#fff"] },
    { name: "Message", style: { padding: "10px 18px", borderRadius: "999px", border: "none", background: "#25D366", color: "#fff", fontWeight: "600", cursor: "pointer" }, hover: ["#1ebe57", "#fff"], out: ["#25D366", "#fff"] },
    { name: "Ask ChatGPT", style: { padding: "8px 10px", borderRadius: "8px", border: "1px solid #10a37f", background: "#0b0f14", color: "white", fontWeight: "600", cursor: "pointer" }, hover: ["#10a37f", "#fff"], out: ["#0b0f14", "white"] },
    { name: "Order Food", style: { padding: "10px 18px", borderRadius: "6px", border: "none", background: "#e23744", color: "#fff", fontWeight: "600", cursor: "pointer" }, hover: ["#c51f2d", "#fff"], out: ["#e23744", "#fff"] },
    { name: "Order Now", style: { padding: "10px 18px", borderRadius: "6px", border: "none", background: "#fc8019", color: "#fff", fontWeight: "600", cursor: "pointer" }, hover: ["#e46f12", "#fff"], out: ["#fc8019", "#fff"] },
    { name: "Buy in 10 min", style: { padding: "8px 10px", borderRadius: "6px", border: "none", background: "#f7d046", color: "#111", fontWeight: "700", cursor: "pointer" }, hover: ["#e6c33d", "#000"], out: ["#f7d046", "#111"] },
    { name: "Quick Buy", style: { padding: "10px 18px", borderRadius: "6px", border: "none", background: "#7b2ff7", color: "#fff", fontWeight: "600", cursor: "pointer" }, hover: ["#6922db", "#fff"], out: ["#7b2ff7", "#fff"] },
    { name: "Buy Now", style: { padding: "10px 18px", borderRadius: "6px", border: "none", background: "#ff9900", color: "#111", fontWeight: "700", cursor: "pointer" }, hover: ["#e68a00", "#000"], out: ["#ff9900", "#111"] },
    { name: "Subscribe", style: { padding: "10px 18px", borderRadius: "999px", border: "none", background: "#ff0000", color: "#fff", fontWeight: "600", cursor: "pointer" }, hover: ["#cc0000", "#fff"], out: ["#ff0000", "#fff"] },
    { name: "Play", style: { padding: "10px 22px", borderRadius: "999px", border: "none", background: "#1DB954", color: "#000", fontWeight: "700", cursor: "pointer" }, hover: ["#17a44b", "#000"], out: ["#1DB954", "#000"] },
    { name: "Watch", style: { padding: "10px 22px", borderRadius: "4px", border: "none", background: "#e50914", color: "#fff", fontWeight: "700", cursor: "pointer" }, hover: ["#b20710", "#fff"], out: ["#e50914", "#fff"] },
    { name: "Sign in with Google", style: { padding: "8px 10px", borderRadius: "6px", border: "1px solid #dadce0", background: "#fff", color: "#3c4043", fontWeight: "600", cursor: "pointer" }, hover: ["#4285f4", "#fff"], out: ["#fff", "#3c4043"] },
    { name: "Continue with Apple", style: { padding: "8px 10px", borderRadius: "60px", border: "none", background: "#000", color: "#fff", fontWeight: "600", cursor: "pointer" }, hover: ["#333", "#fff"], out: ["#000", "#fff"] },
    { name: "Pay Securely", style: { padding: "8px 10px", borderRadius: "999px", border: "none", background: "#0ea5e9", color: "#fff", fontWeight: "700", cursor: "pointer" }, hover: ["#0284c7", "#fff"], out: ["#0ea5e9", "#fff"] },
    { name: "Get Started", style: { padding: "8px 10px", borderRadius: "999px", border: "none", background: "#22c55e", color: "#fff", fontWeight: "700", cursor: "pointer" }, hover: ["#16a34a", "#fff"], out: ["#22c55e", "#fff"] },
    { name: "Go Premium", style: { padding: "8px 10px", borderRadius: "60px", border: "1px solid gold", background: "linear-gradient(45deg,#ffd700,#ffb700)", color: "#000", fontWeight: "800", cursor: "pointer" }, hover: ["#ffb700", "#000"], out: ["linear-gradient(45deg,#ffd700,#ffb700)", "#000"] },
  ];

  const [openCode, setOpenCode] = useState(null);
  const [tab, setTab] = useState("react");

  const generateReactCode = (btn) => `
<button
  style={{
${Object.entries(btn.style).map(([k, v]) => `    ${k}: "${v}",`).join("\n")}
  }}
  onMouseOver={(e) => {
    e.currentTarget.style.background = "${btn.hover[0]}";
    e.currentTarget.style.color = "${btn.hover[1]}";
  }}
  onMouseOut={(e) => {
    e.currentTarget.style.background = "${btn.out[0]}";
    e.currentTarget.style.color = "${btn.out[1]}";
  }}
>
  ${btn.name}
</button>
`.trim();

  const generateHTMLCode = (btn) => {
    const styleString = Object.entries(btn.style).map(([k, v]) => `${k}:${v}`).join(";");
    return `
<button
  style="${styleString}"
  onmouseover="this.style.background='${btn.hover[0]}';this.style.color='${btn.hover[1]}'"
  onmouseout="this.style.background='${btn.out[0]}';this.style.color='${btn.out[1]}'"
>
  ${btn.name}
</button>
`.trim();
  };

  const downloadJSX = (btn) => {
    const blob = new Blob([generateReactCode(btn)], { type: "text/plain" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${btn.name.toLowerCase().replace(/\s/g, "-")}.jsx`;
    link.click();
  };

  return (
    <>
      <div style={pageStyle}>
        {buttons.map((btn, i) => (
          <div key={i} style={wrapperStyle}>
            <div style={cardStyle}>
              <button
                style={btn.style}
                onMouseOver={(e) => hoverIn(e, btn.hover[0], btn.hover[1])}
                onMouseOut={(e) => hoverOut(e, btn.out[0], btn.out[1])}
              >
                {btn.name}
              </button>
            </div>

            <button
              style={viewBtnStyle}
              onClick={() => {
                setOpenCode(btn);
                setTab("react");
              }}
            >
              View Code
            </button>
          </div>
        ))}
      </div>

      {/* ---------- MODAL ---------- */}
      {openCode && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,.4)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "12px",   // mobile spacing
          }}
        >
          <div
            style={{
              width: "100%",
              maxWidth: "640px",
              maxHeight: "90vh",
              background: "#0b0f14",
              color: "#e5e7eb",
              borderRadius: "12px",
              padding: "16px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <strong>{openCode.name} Code</strong>
              <button onClick={() => setOpenCode(null)} style={{ background: "none", border: "none", color: "#fff" }}>✕</button>
            </div>

            <div style={{ display: "flex", gap: "8px", marginTop: "10px", flexWrap: "wrap" }}>
              {["react", "html"].map((t) => (
                <button
                  key={t}
                  onClick={() => setTab(t)}
                  style={{
                    padding: "6px 10px",
                    borderRadius: "6px",
                    border: "none",
                    background: tab === t ? "green" : "#1f2933",
                    color: "#fff",
                  }}
                >
                  {t.toUpperCase()}
                </button>
              ))}
            </div>

            <pre
              style={{
                marginTop: "12px",
                background: "#020617",
                padding: "14px",
                borderRadius: "8px",
                maxHeight: "40vh",
                overflow: "auto",
                color: "#ddd",
                fontSize: "13px",
              }}
            >
              {tab === "react" ? generateReactCode(openCode) : generateHTMLCode(openCode)}
            </pre>

            <div style={{ display: "flex", gap: "8px", marginTop: "12px", flexWrap: "wrap" }}>
              <button
                onClick={() =>
                  navigator.clipboard.writeText(
                    tab === "react" ? generateReactCode(openCode) : generateHTMLCode(openCode)
                  )
                }
                style={{ padding: "8px 12px", borderRadius: "6px", border: "none", background: "green", color: "#fff" }}
              >
                Copy Code
              </button>

              {tab === "react" && (
                <button
                  onClick={() => downloadJSX(openCode)}
                  style={{ padding: "8px 12px", borderRadius: "6px", border: "none", background: "#1d4ed8", color: "#fff" }}
                >
                  Download .jsx
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
